import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import ToolTip, {tooltipPositions} from '../../../ui/components/ToolTip.jsx';
import {formatCurrency} from '../../helpers/currencyHelper.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class DashboardPurchase extends React.Component {
  static propTypes = {
    numberAnalysesYTD: PropTypes.number,
    lifetimePurchases: PropTypes.number,
    lastPurchaseAmount: PropTypes.number,
    lastPurchaseDate: PropTypes.string,
    totalPurchaseAmountYTD: PropTypes.number,
    avgPurchasePerAnalysis: PropTypes.number,
    threeStepPurchase: PropTypes.number,
    intl: intlShape.isRequired,
  };

  getFormattedNumber = (number) => {
    if (number === null || number === undefined || isNaN(number) || typeof number !== 'number') {
      return 0;
    }
    return number % 1 !== 0 ? number.toFixed(2) : number;
  };

  render() {
    const {formatMessage} = this.props.intl;

    let lastPurchaseDate = this.props.lastPurchaseDate && moment(this.props.lastPurchaseAmount).isValid() ?
      moment(this.props.lastPurchaseDate).format('ll') :
      formatMessage({id: 'general.none'});

    return (
      <div className="purchase-history row">
        <h2>
          <FormattedMessage id="customer.purchase.history.title" />
          <ToolTip title={this.props.intl.formatMessage({id: 'customer.purchase.history.tooltip'})}
            position={tooltipPositions.topRight} iconOnly />
        </h2>
        <div className="purchase-history-grid">
          <div className="purchase-history-row row">
            <div className="purchase-data col-sm-4">
              <div>
                <p><FormattedMessage id="general.purchase.last.purchase" /></p>
                <h2>{formatCurrency(this.props.lastPurchaseAmount)}</h2>
                <p className="bottom-paragraph">{lastPurchaseDate}</p>
              </div>
            </div>
            <div className="purchase-data col-sm-4">
              <div>
                <p><FormattedMessage id="customer.purchase.yeartodate.analyses" /></p>
                <h2>{this.props.numberAnalysesYTD}</h2>
                <p className="bottom-paragraph"/>
              </div>
            </div>
            <div className="purchase-data col-sm-4">
              <div>
                <p><FormattedMessage id="customer.purchase.yeartodate.purchases" /></p>
                <h2>{formatCurrency(this.props.totalPurchaseAmountYTD)}</h2>
                <p className="bottom-paragraph"/>
              </div>
            </div>
          </div>
          <div className="purchase-history-row row">
            <div className="purchase-data col-sm-4">
              <div>
                <p><FormattedMessage id="customer.purchase.lifetime.purchases" /></p>
                <h2 className='offset-margin-top'>{formatCurrency(this.props.lifetimePurchases)}</h2>
                <p className="bottom-paragraph"/>
              </div>
            </div>
            <div className="purchase-data col-sm-4">
              <div>
                <p><FormattedMessage id="customer.purchase.yeartodate.spend" /></p>
                <h2 className='offset-margin-top'>{formatCurrency(this.props.avgPurchasePerAnalysis)}</h2>
                <p className="bottom-paragraph"/>
              </div>
            </div>
            <div className="purchase-data col-sm-4">
              <div>
                <p><FormattedMessage id="customer.purchase.3step.purchases" /></p>
                <h2 className='offset-margin-top'>{formatCurrency(this.props.threeStepPurchase)}</h2>
                <p className="bottom-paragraph"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(DashboardPurchase);
